import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for createPortal
import './SerialNumberBadge.css';
import { RiEdit2Line } from "react-icons/ri"; 
import { useSelector } from 'react-redux'; 
import { selectUser } from '../../redux/features/auth/authSlice'; 

const SerialNumberBadge = ({ serialNumber, note, onRemove, isRemovable = false, onEditNote, onGoToUpdatePage }) => {
    const [isHovered, setIsHovered] = useState(false);
    const user = useSelector(selectUser); 
    const isUserAdmin = user?.permission === 'admin' || user?.permission === 'editor'; 
    const badgeRef = useRef(null); // Ref for the badge span
    const [tooltipStyle, setTooltipStyle] = useState({
        opacity: 0,
        visibility: 'hidden',
        top: '0px',
        left: '0px'
    });

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (note && badgeRef.current) {
            const rect = badgeRef.current.getBoundingClientRect();
            // Position the tooltip above the badge
            // 'top' is set to the badge's top, CSS transform will move it above
            // 'left' is set to the badge's horizontal center, CSS transform will center it
            const topPos = rect.top; 
            const leftPos = rect.left + rect.width / 2;

            setTooltipStyle({
                top: `${topPos}px`,
                left: `${leftPos}px`,
                opacity: 1,
                visibility: 'visible',
            });
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        // Start fade out, CSS transition will handle the rest
        setTooltipStyle(prev => ({ ...prev, opacity: 0, visibility: 'hidden' }));
    };

    return (
        <>
            <span
                ref={badgeRef}
                className="serial-badge"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {serialNumber}
            <div className="badge-actions"> {/* Container for hover buttons */}
                {isHovered && onEditNote && (
                    <button
                        type="button"
                        onClick={onEditNote}
                        className="badge-action-btn edit-note-btn" /* Updated class */
                        title="Edit note for this serial"
                    >
                        <RiEdit2Line size={14} />
                    </button>
                )}
                {isHovered && onGoToUpdatePage && isUserAdmin &&(
                    <button
                        type="button"
                        onClick={onGoToUpdatePage}
                        className="badge-action-btn update-product-btn" /* New class */
                        title="Go to product update page to edit notes and other details"
                    >
                        <RiEdit2Line size={14} /> {/* Changed to icon */}
                    </button>
                )}
            </div>
            {isRemovable && (
                <button
                    type="button"
                    onClick={onRemove}
                    className="remove-serial-btn"
                >
                    ×
                </button>
            )}
            </span>
            {note && ReactDOM.createPortal(
                <div className="custom-tooltip" style={tooltipStyle}>
                    {note}
                </div>,
                document.body // Render tooltip directly into document.body
            )}
        </>
    );
};

export default SerialNumberBadge;